<template>
  <div class="rich-text">
    <viewer
      v-if="images.length"
      :images="images"
      :options="viewerOptions">
      <div v-safe-html="html" />
    </viewer>
    <div
      v-else
      v-safe-html="html" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { renderRichText } from '@/helpers/richText';

const props = defineProps({
  value: { type: String, default: '' },
});

const vSafeHtml = {
  mounted(el, binding) {
    el.innerHTML = binding.value;
  },
  updated(el, binding) {
    el.innerHTML = binding.value;
  },
};

const html = computed(() => renderRichText(props.value));

// Картинки внутри комментария открываются тем же просмотрщиком, что и скриншоты замечания.
const images = computed(() => {
  if (!html.value.includes('<img')) return [];

  const doc = new DOMParser().parseFromString(html.value, 'text/html');
  return Array.from(doc.querySelectorAll('img'))
    .map((image) => image.getAttribute('src'))
    .filter(Boolean);
});

const viewerOptions = {
  loop: false,
  navbar: false,
  tooltip: false,
  scalable: false,
  toolbar: false,
  title: false,
};
</script>

<style scoped>
.rich-text {
  overflow-wrap: anywhere;
}
.rich-text :deep(p) {
  margin-bottom: 4px;
}
.rich-text :deep(p:last-child) {
  margin-bottom: 0;
}
.rich-text :deep(img) {
  display: block;
  max-width: 100%;
  margin: 6px 0;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  cursor: zoom-in;
}
.rich-text :deep(ul),
.rich-text :deep(ol) {
  margin-bottom: 4px;
  padding-left: 20px;
}
.rich-text :deep(pre) {
  overflow-x: auto;
  padding: 8px;
  border-radius: 6px;
  background: #fafafa;
}
.rich-text :deep(table) {
  border-collapse: collapse;
}
.rich-text :deep(td),
.rich-text :deep(th) {
  border: 1px solid #f0f0f0;
  padding: 4px 8px;
}
</style>
